<div class="page has-title">
  <ng-container *ngIf="user$ | async as user; else loading">
    <ng-container *ngIf="legacyItem && user; else loading">
      <h1>{{ title }}</h1>

      <div class="row">
        <div class="col-md-3">
          <astrobin-migration-nav></astrobin-migration-nav>
        </div>
        <div class="col-md-9">
          <div class="card box-shadow">
            <div class="card-header">
              {{ "Summary" | translate }}
            </div>

            <div class="card-body">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <th scope="col">{{ "Object ID" | translate }}</th>
                    <td>{{ legacyItem.pk }}</td>
                  </tr>
                  <tr>
                    <th scope="col">{{ "Brand/Make" | translate }}</th>
                    <td>{{ legacyItem.make || "(no brand)" }}</td>
                  </tr>
                  <tr>
                    <th scope="col">{{ "Name/Model" | translate }}</th>
                    <td>{{ legacyItem.name || "(no name)" }}</td>
                  </tr>
                  <tr *ngFor="let key of gearService.getProperAttributes(legacyItem)">
                    <th scope="col">{{ key | camelCaseToSentenceCase }}</th>
                    <td>{{ legacyItem[key] !== null ? legacyItem[key] : "n/a" }}</td>
                  </tr>
                  <tr>
                    <th scope="col">Proposed strategy</th>
                    <td>{{ migrationStrategy.migrationFlag }}</td>
                  </tr>
                  <tr>
                    <th scope="col">Global or Personal</th>
                    <td>
                      <ng-container *ngIf="!migrationStrategy.user">
                        Global
                        <span
                          class="help-tooltip"
                          ngbTooltip="
                            Global migrations apply to all owners of the legacy item and were created by a moderator.
                          "
                        >
                          <fa-icon icon="question-circle"></fa-icon>
                        </span>
                      </ng-container>
                      <ng-container *ngIf="!!migrationStrategy.user">
                        Personal
                        <span
                          class="help-tooltip"
                          ngbTooltip="
                            Personal migrations apply only to legacy items appearing on the images of the end user who
                            created this migration.
                          "
                        >
                          <fa-icon icon="question-circle"></fa-icon>
                        </span>
                      </ng-container>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">{{ "Proposed by" | translate }}</th>
                    <td>
                      <astrobin-username [user]="user" linkTarget="_blank"></astrobin-username>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">{{ "When" | translate }}</th>
                    <td>{{ migrationStrategy.migrationFlagTimestamp | timeago }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="showButtonsOnSummary" class="card-footer">
              <ng-container [ngTemplateOutlet]="buttons"></ng-container>
            </div>
          </div>

          <ng-container *ngIf="migrationStrategy.migrationFlag === MigrationFlag.MIGRATE">
            <div class="mt-4 mb-4 text-center">
              <fa-icon icon="arrow-down"></fa-icon>
            </div>

            <div class="card box-shadow">
              <div class="card-header">The legacy object will be migrated to the following equipment item</div>

              <div class="card-body">
                <ng-container *ngIf="equipmentItem; else loading">
                  <astrobin-equipment-item-summary
                    [item]="equipmentItem"
                    [showEmptyProperties]="true"
                    [showMeta]="true"
                  ></astrobin-equipment-item-summary>
                </ng-container>
              </div>

              <div class="card-footer">
                <ng-container [ngTemplateOutlet]="buttons"></ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #buttons>
  <button [class.loading]="loadingService.loading$ | async" (click)="approve()" class="btn btn-sm-block btn-success">
    {{ "Approve" | translate }}
  </button>

  <button [class.loading]="loadingService.loading$ | async" (click)="reject()" class="btn btn-sm-block btn-danger">
    {{ "Reject" | translate }}&hellip;
  </button>

  <button [class.loading]="loadingService.loading$ | async" (click)="exit()" class="btn btn-sm-block btn-secondary">
    {{ "Cancel" | translate }}
  </button>
</ng-template>
